export default __webpack_public_path__ + "static/media/pause.ff68b4db.svg";